module.exports = {
	baseURL: 'https://staging.dochq.co.uk/',
	baseAPI: 'https://staging.dochq.co.uk/api/',
	discountAPI: 'https://services-discounts-staging.dochq.co.uk/',
	covid19API: 'https://services-covid-19-staging.dochq.co.uk/',
	contactAPI: 'https://dochq-contact-api-staging.dochq.co.uk',
	brochureAPI: 'https://hooks.zapier.com/hooks/catch/4296899/orfbark/',
	featureFlags: {},
};
